import type { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { bffApi } from "../../autogen/bff-api";
import { reloadMeThunk } from "./thunks/auth/reload-me-thunk";

type Dispatch = ThunkDispatch<unknown, unknown, AnyAction>;

let reloading: Promise<void> | null = null;
let reloadRequestedWhileReloading = false;

const reloadSelectedOrg = (dispatch: Dispatch): Promise<void> => {
  if (reloading) {
    reloadRequestedWhileReloading = true;
    return reloading;
  }
  reloading = (async () => {
    try {
      do {
        reloadRequestedWhileReloading = false;
        await dispatch(reloadMeThunk());
      } while (reloadRequestedWhileReloading);
    } finally {
      reloading = null;
    }
  })();
  return reloading;
};

export const reloadSelectedOrgWhenFulfilled = async (
  _arg: unknown,
  { dispatch, queryFulfilled }: { dispatch: Dispatch; queryFulfilled: Promise<unknown> },
) => {
  try {
    await queryFulfilled;
  } catch {
    return;
  }
  await reloadSelectedOrg(dispatch);
};

bffApi.enhanceEndpoints({
  endpoints: {
    createDepartment: { onQueryStarted: reloadSelectedOrgWhenFulfilled },
    renameDepartment: { onQueryStarted: reloadSelectedOrgWhenFulfilled },
    activateDepartment: { onQueryStarted: reloadSelectedOrgWhenFulfilled },
    deactivateDepartment: { onQueryStarted: reloadSelectedOrgWhenFulfilled },
    assignDepartmentRole: { onQueryStarted: reloadSelectedOrgWhenFulfilled },
    revokeDepartmentRole: { onQueryStarted: reloadSelectedOrgWhenFulfilled },
  },
});
